import React from 'react';

interface SolidDotProps {
	color?: string;
	size?: number | string;
	className?: string;
}

export const SolidDot = ({
	color = 'bg-[#FF0043]',
	size = '2px',
	className,
}: SolidDotProps) => {
	return (
		<div
			className={`w-[${size}] h-[${size}] rounded-full ${color} ${className}`}
			style={{ border: '1.5px solid #FFFFFF', width: size, height: size }}
		/>
	);
};
